var map = {
	"./PinkBag.png": 7469,
	"./about.png": 156,
	"./about2.png": 8340,
	"./bags.png": 9782,
	"./file-20231206-34417-smw7n5.avif": 4162,
	"./glasses.png": 9811,
	"./icon.png": 6328,
	"./pacemakers-what-you-should-know-1745231_v2-da71dbec46b345308dd2fcbb65cc638b.webp": 7225,
	"./personalcare.jpeg": 2618,
	"./personalcare.png": 800,
	"./product-image.png": 5762,
	"./watch.png": 7986,
	"./العصرية.jpg": 312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;